var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTasks1Of3(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#000"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m11.9844 23c0-.8284.6715-1.5 1.5-1.5h12c.8284 0 1.5.6716 1.5 1.5s-.6716 1.5-1.5 1.5h-12c-.8285 0-1.5-.6716-1.5-1.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m11.9844 16c0-.8284.6715-1.5 1.5-1.5h12c.8284 0 1.5.6716 1.5 1.5s-.6716 1.5-1.5 1.5h-12c-.8285 0-1.5-.6716-1.5-1.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m12 9c0-.82843.6716-1.5 1.5-1.5h12c.8284 0 1.5.67157 1.5 1.5s-.6716 1.5-1.5 1.5h-12c-.8284 0-1.5-.67157-1.5-1.5z"
  }), /*#__PURE__*/React.createElement("g", {
    clipRule: "evenodd",
    fillRule: "evenodd",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "m5 23c0 1.383 1.11702 2.5 2.5 2.5s2.5-1.117 2.5-2.5-1.11702-2.5-2.5-2.5-2.5 1.117-2.5 2.5zm2.5 1.6489c.90426 0 1.64894-.7446 1.64894-1.6489 0-.9308-.71809-1.6755-1.64894-1.6755s-1.64894.7712-1.64894 1.6755.74469 1.6489 1.64894 1.6489z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m5 23c0 1.383 1.11702 2.5 2.5 2.5s2.5-1.117 2.5-2.5-1.11702-2.5-2.5-2.5-2.5 1.117-2.5 2.5zm2.5 1.6489c.90426 0 1.64894-.7446 1.64894-1.6489 0-.9308-.71809-1.6755-1.64894-1.6755s-1.64894.7712-1.64894 1.6755.74469 1.6489 1.64894 1.6489z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m5 16c0 1.383 1.11702 2.5 2.5 2.5s2.5-1.117 2.5-2.5-1.11702-2.5-2.5-2.5-2.5 1.117-2.5 2.5zm2.5 1.6489c.90426 0 1.64894-.7446 1.64894-1.6489 0-.9308-.71809-1.6755-1.64894-1.6755s-1.64894.7712-1.64894 1.6755.74469 1.6489 1.64894 1.6489z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m5 16c0 1.383 1.11702 2.5 2.5 2.5s2.5-1.117 2.5-2.5-1.11702-2.5-2.5-2.5-2.5 1.117-2.5 2.5zm2.5 1.6489c.90426 0 1.64894-.7446 1.64894-1.6489 0-.9308-.71809-1.6755-1.64894-1.6755s-1.64894.7712-1.64894 1.6755.74469 1.6489 1.64894 1.6489z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m9.87805 7.30975c.17735-.23719.13305-.47437.04434-.60614-.13303-.21083-.35476-.26354-.50997-.13177-.96467.98277-1.87238 2.02724-2.81596 3.03069l-.90653-1.13322c-.14533-.17273-.40679-.17164-.55689-.0527-.08869.07906-.13304.21083-.13304.3426 0 .07906 0 .13176.02217.18447.302.71789.66041 1.40662.99778 2.10832.04435.1318.15522.2635.26608.3426.06652.079.17739.1054.28825.1054.19956 0 .42129-.1054.55433-.2899.03324-.0527.07211-.1055.1109-.1582.90304-1.22664 1.75451-2.5004 2.63854-3.74215z",
    opacity: 0.6
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTasks1Of3);
export default __webpack_public_path__ + "static/media/Tasks-1of3.878a55067c671df8bc50448977acca79.svg";
export { ForwardRef as ReactComponent };